<template>
    <search-group title="功能区查询" @search="findData" @clear="clearValue">
        <Row class="mb16" :gutter="16">
            <Col span="6">
                 <Select v-model="searchData.projectId" placeholder="请选择项目" @on-change="changeProject">
                    <Option value="">请选择</Option>
                    <Option value="100" v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="6">
                 <Select v-model="searchData.buildingId" @on-change="changBuiding" placeholder="请选择楼栋">
                    <Option value="">{{searchData.projectId !==''?(buildingList.length===0?'暂无数据':'请选择'):'请先选择项目'}}</Option>
                    <Option value="100" v-for="item in buildingList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="6">
                 <Select v-model="searchData.floor" placeholder="请选择楼层">
                    <Option value="">{{floorList.length===0?'请先选择楼栋':'请选择'}}</Option>
                    <Option value="100" v-for="item in floorList" :value="item.value" :key="item.value">{{item.text}}</Option>
                </Select>
            </Col>
            <Col span="6">
                <Input type="text" placeholder="请输入功能区名称" v-model="searchData.name" @keyup.enter.native="findData"></Input>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">

import SearchGroup from 'components/SearchGroup/index';
export default {
    props:{
      projectList: {
        type: Array,
        default:null
      }
    },
    components: {
        SearchGroup
    },

    data () {
        return {
            searchData: {

              projectId: "",
              buildingId: "",
              floor: "",
              name:"",
              page: 1,
              limit: 10
            },
            buildingList:[],
            floorList:[]
        }
    },
    methods: {
        findData() {
            this.$emit('findData', this.searchData);
        },
        clearValue() {
            this.searchData.projectId = '';
            this.searchData.buildingId= "";
            this.searchData.floor= ""
            this.searchData.name=""

        },
        changeProject(value) {
          for (let [index, item] of this.projectList.entries()) {
            if (value === item.value) {
              this.buildingList = this.projectList[index].children;
            }
          }
          if(!this.searchData.projectId){
            this.buildingList=[]
          }
          this.floorList=[]
        },
        changBuiding(value) {
          for (let [index, item] of this.buildingList.entries()) {
            if (value === item.value) {
              this.floorList = this.buildingList[index].children;

          }
          if(!this.searchData.buildingId){
            this.floorList=[]
          }
        }
      }
    }
}
</script>
